<section class="content">
  <h1 class="title">Vorbestellung Dashboard</h1>
  <div class="tiles-area">
    <div class="tile"
         routerLink="/admin/preorders-deliveries">
      <div class="img-box">
        <div class="d-flex jcc tile-icon icon-hageda">&nbsp;</div>
      </div>
      <h3 class="text-center">Auslieferung ></h3>
    </div>
  </div>
</section>
